module.exports = __webpack_public_path__ + "img/smiletolife_32da2c0c01c1c34d9c8afea55a9a4428.longcache.jpg";